/**
 * Async version of setTimeout
 * @param count milliseconds to wait
 *
 * @usage
 *
 * ```ts
 * await timeout(1000);
 * doStuff();
 * ```
 */
export function timeout(count: number) {
    return new Promise((resolve) => setTimeout(resolve, count));
}
